import React from 'react';
import WindowIcon from '../../SVG/WindowIcon';
import './styles.scss';

const MobileWarning = () => {
  return (
    <div className='mobile_warning'>
      <h1 className='title'>Use a Desktop for Best View</h1>
      <div className='icon'>
        <WindowIcon />
      </div>
      <p className='description'>
        This site may not display properly on mobile.
      </p>
    </div>
  );
};

export default MobileWarning;
